
<template>
<div class="grid-content">
    <div class="box parentflex">
        <p>今日用能统计/总产量</p>
        <div class="count">
            <div class="cardflex">
                <!-- <div class="card padding flex">
                    <div class="box parentbox">
                        <div class="valuebox">
                            <p class="biaoti">总用电量</p>
                            <p class="danwei">(kW▪h)</p>
                        </div>
                        <div class="valuebox bgpadding">
                            <div class="valuebg">
                                <div class="energyImg yearPower_"></div>
                            </div>
                        </div>
                        <div class="valuebox bgpadding">
                            <div class="valuebg valuebgcolor">
                                <p class="elem">{{ydl}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card padding flex">
                    <div class="box parentbox">
                        <div class="valuebox">
                            <p class="biaoti">总产量</p>
                            <p class="danwei">(片)</p>
                        </div>
                        <div class="valuebox bgpadding">
                            <div class="valuebg">
                                <div class="energyImg yearOutput"></div>
                            </div>
                        </div>
                        <div class="valuebox bgpadding">
                            <div class="valuebg valuebgcolor">
                                <p class="puduct">{{yd}}</p>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="card padding flex" v-for="(item,index) in carddata" :key="index">
                    <div class="box parentbox">
                        <div class="valuebox">
                            <p class="biaoti">{{item.name}}</p>
                            <p class="danwei">{{item.unit}}</p>
                        </div>
                        <div class="valuebox bgpadding">
                            <div class="valuebg">
                                <div class="energyImg " :class="item.icon"></div>
                            </div>
                        </div>
                        <div class="valuebox bgpadding">
                            <div class="valuebg valuebgcolor">
                                <p class="elem">{{item.value}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
   props:{
           carddata:{//echarts数据
                type:Array,//类型只能是数组
                default:[]
            }
        }, 
  data () {
    return {
        ydl:'',//单片用电量
        ysl:'',//单片用水量
        yd:'',//用电量
    };
  },
  mounted(){
  },
  watch:{
      carddata(curval,oldval){
          this.ydl=curval[0],
          this.yd=curval[1]
      }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
/* 左上卡片 */
.relative{position:relative;}
.box_{width:100%;height:100%;overflow: hidden;padding: 10px;box-sizing: border-box;}
.flex{display:flex;flex-wrap:wrap;align-items: center;}
.cardflex{display:flex;justify-content:center;align-items:center;width: 100%;height:95%}
.card{width:48%;height:100%;border:1px solid #cccccc;margin: 5px;border-radius:3px;}
.parentbox{display:flex;flex-direction: column;}
.valuebox{flex:1;width:100%;display:flex;justify-content:center;align-items:center;flex-direction: column;}
.bgpadding{padding:6%;box-sizing:border-box;}
.valuebg{color:#002F7A;display:flex;justify-content:center;align-items:center;width: 100%;height:100%;border-radius:3px;}
.valuebgcolor{background:#CFD0D2;}
.valuebg p{color:#002F7A;font-size:24px;font-weight: 600;}
.biaoti{font-size:18px;}
.danwei{font-size:18px;}
.bluetxt{font-size:20px;font-weight:bold;}
.bluecolor{color:#002F7A;}
.count{position:absolute;top:2.3rem;left:0;right:0;bottom:0;background:#fff;box-shadow:0 0 10px 2px #CCD7E8;box-sizing:border-box;}
.countUl{list-style:none;overflow:hidden;display:flex;margin-left:5%;}
.countUl li{font-size:1rem;line-height:1.5rem;box-sizing:border-box;margin-right:10px;text-align:center;width:100px}
.energyImg{display:inline-block;width:1.65rem;height:1.65rem;border-radius:1.65rem}
.grid-content{width:100%;height:100%;overflow: hidden;background: #fff;box-shadow:0 0 10px 2px #CCD7E8;border: 1px solid #CCD7E8;border-radius: 10px; text-align: left;}
.parentflex{position: relative;padding:5px;box-sizing:border-box;background: #fff;padding-top:1px}
.parentflex>p{width:100%;height:2.2rem;line-height:2.2rem;font-size:1.4rem;padding-left:1rem;font-weight:bold;-webkit-box-sizing:border-box;box-sizing:border-box;}
.content{position: absolute;top:35px;bottom:5px;left: 5px;right: 5px;}
.box{width:100%;height:100%;overflow: hidden;padding: 10px;box-sizing: border-box;background:#fff;padding-top:1px}
/* 左上卡片 */
// 上左边
.yearZhny{background:#fff url(../../../assets/image/index/zhnyl.png) no-repeat center center}
.yearFire{background:#fff url(../../../assets/image/index/icon.png) no-repeat -0.5rem -19.5rem}
.yearElect{background:#fff url(../../../assets/image/index/zhnyldian.png) no-repeat center center}
.yearWater_{background:#fff url(../../../assets/image/index/water_.png) no-repeat center center}
.yearPower_{background:#fff url(../../../assets/image/index/power_.png) no-repeat center center}
.yearOutput{background:#fff url(../../../assets/image/index/output.png) no-repeat center center}
// 上左边
</style>